/**
 * @see https://github.com/aws-amplify/amplify-js/issues/9104
 * @see https://github.com/aws-amplify/amplify-js/blob/main/packages/auth/src/providers/cognito/types/errors.ts
 */
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

export const AssociateSoftwareTokenException = {
  ConcurrentModificationException: "ConcurrentModificationException",
  ForbiddenException: "ForbiddenException",
  InternalErrorException: "InternalErrorException",
  InvalidParameterException: "InvalidParameterException",
  NotAuthorizedException: "NotAuthorizedException",
  ResourceNotFoundException: "ResourceNotFoundException",
  SoftwareTokenMFANotFoundException: "SoftwareTokenMFANotFoundException",
} as const;

export const ChangePasswordException = {
  ForbiddenException: "ForbiddenException",
  InternalErrorException: "InternalErrorException",
  InvalidParameterException: "InvalidParameterException",
  InvalidPasswordException: "InvalidPasswordException",
  LimitExceededException: "LimitExceededException",
  NotAuthorizedException: "NotAuthorizedException",
  PasswordResetRequiredException: "PasswordResetRequiredException",
  ResourceNotFoundException: "ResourceNotFoundException",
  TooManyRequestsException: "TooManyRequestsException",
  UserNotConfirmedException: "UserNotConfirmedException",
  UserNotFoundException: "UserNotFoundException",
} as const;

export const ConfirmDeviceException = {
  ForbiddenException: "ForbiddenException",
  InternalErrorException: "InternalErrorException",
  InvalidLambdaResponseException: "InvalidLambdaResponseException",
  InvalidParameterException: "InvalidParameterException",
  InvalidPasswordException: "InvalidPasswordException",
  InvalidUserPoolConfigurationException:
    "InvalidUserPoolConfigurationException",
  NotAuthorizedException: "NotAuthorizedException",
  PasswordResetRequiredException: "PasswordResetRequiredException",
  ResourceNotFoundException: "ResourceNotFoundException",
  TooManyRequestsException: "TooManyRequestsException",
  UsernameExistsException: "UsernameExistsException",
  UserNotConfirmedException: "UserNotConfirmedException",
  UserNotFoundException: "UserNotFoundException",
} as const;

export const ConfirmForgotPasswordException = {
  CodeMismatchException: "CodeMismatchException",
  ExpiredCodeException: "ExpiredCodeException",
  ForbiddenException: "ForbiddenException",
  InternalErrorException: "InternalErrorException",
  InvalidLambdaResponseException: "InvalidLambdaResponseException",
  InvalidParameterException: "InvalidParameterException",
  InvalidPasswordException: "InvalidPasswordException",
  LimitExceededException: "LimitExceededException",
  NotAuthorizedException: "NotAuthorizedException",
  ResourceNotFoundException: "ResourceNotFoundException",
  TooManyFailedAttemptsException: "TooManyFailedAttemptsException",
  TooManyRequestsException: "TooManyRequestsException",
  UnexpectedLambdaException: "UnexpectedLambdaException",
  UserLambdaValidationException: "UserLambdaValidationException",
  UserNotConfirmedException: "UserNotConfirmedException",
  UserNotFoundException: "UserNotFoundException",
} as const;

export const ConfirmSignUpException = {
  AliasExistsException: "AliasExistsException",
  CodeMismatchException: "CodeMismatchException",
  ExpiredCodeException: "ExpiredCodeException",
  ForbiddenException: "ForbiddenException",
  InternalErrorException: "InternalErrorException",
  InvalidLambdaResponseException: "InvalidLambdaResponseException",
  InvalidParameterException: "InvalidParameterException",
  LimitExceededException: "LimitExceededException",
  NotAuthorizedException: "NotAuthorizedException",
  ResourceNotFoundException: "ResourceNotFoundException",
  TooManyFailedAttemptsException: "TooManyFailedAttemptsException",
  TooManyRequestsException: "TooManyRequestsException",
  UnexpectedLambdaException: "UnexpectedLambdaException",
  UserLambdaValidationException: "UserLambdaValidationException",
  UserNotFoundException: "UserNotFoundException",
} as const;

export const DeleteUserAttributesException = {
  ForbiddenException: "ForbiddenException",
  InternalErrorException: "InternalErrorException",
  InvalidParameterException: "InvalidParameterException",
  NotAuthorizedException: "NotAuthorizedException",
  PasswordResetRequiredException: "PasswordResetRequiredException",
  ResourceNotFoundException: "ResourceNotFoundException",
  TooManyRequestsException: "TooManyRequestsException",
  UserNotConfirmedException: "UserNotConfirmedException",
  UserNotFoundException: "UserNotFoundException",
} as const;

export const DeleteUserException = {
  ForbiddenException: "ForbiddenException",
  InternalErrorException: "InternalErrorException",
  InvalidParameterException: "InvalidParameterException",
  NotAuthorizedException: "NotAuthorizedException",
  PasswordResetRequiredException: "PasswordResetRequiredException",
  ResourceNotFoundException: "ResourceNotFoundException",
  TooManyRequestsException: "TooManyRequestsException",
  UserNotConfirmedException: "UserNotConfirmedException",
  UserNotFoundException: "UserNotFoundException",
} as const;

export const ForgetDeviceException = {
  ForbiddenException: "ForbiddenException",
  InternalErrorException: "InternalErrorException",
  InvalidParameterException: "InvalidParameterException",
  InvalidUserPoolConfigurationException:
    "InvalidUserPoolConfigurationException",
  NotAuthorizedException: "NotAuthorizedException",
  PasswordResetRequiredException: "PasswordResetRequiredException",
  ResourceNotFoundException: "ResourceNotFoundException",
  TooManyRequestsException: "TooManyRequestsException",
  UserNotConfirmedException: "UserNotConfirmedException",
  UserNotFoundException: "UserNotFoundException",
} as const;

export const ForgotPasswordException = {
  CodeDeliveryFailureException: "CodeDeliveryFailureException",
  ForbiddenException: "ForbiddenException",
  InternalErrorException: "InternalErrorException",
  InvalidEmailRoleAccessPolicyException:
    "InvalidEmailRoleAccessPolicyException",
  InvalidLambdaResponseException: "InvalidLambdaResponseException",
  InvalidParameterException: "InvalidParameterException",
  InvalidSmsRoleAccessPolicyException: "InvalidSmsRoleAccessPolicyException",
  InvalidSmsRoleTrustRelationshipException:
    "InvalidSmsRoleTrustRelationshipException",
  LimitExceededException: "LimitExceededException",
  NotAuthorizedException: "NotAuthorizedException",
  ResourceNotFoundException: "ResourceNotFoundException",
  TooManyRequestsException: "TooManyRequestsException",
  UnexpectedLambdaException: "UnexpectedLambdaException",
  UserLambdaValidationException: "UserLambdaValidationException",
  UserNotFoundException: "UserNotFoundException",
} as const;

export const GetUserException = {
  ForbiddenException: "ForbiddenException",
  InternalErrorException: "InternalErrorException",
  InvalidParameterException: "InvalidParameterException",
  NotAuthorizedException: "NotAuthorizedException",
  PasswordResetRequiredException: "PasswordResetRequiredException",
  ResourceNotFoundException: "ResourceNotFoundException",
  TooManyRequestsException: "TooManyRequestsException",
  UserNotConfirmedException: "UserNotConfirmedException",
  UserNotFoundException: "UserNotFoundException",
} as const;

export const GetIdException = {
  ExternalServiceException: "ExternalServiceException",
  InternalErrorException: "InternalErrorException",
  InvalidParameterException: "InvalidParameterException",
  LimitExceededException: "LimitExceededException",
  NotAuthorizedException: "NotAuthorizedException",
  ResourceConflictException: "ResourceConflictException",
  ResourceNotFoundException: "ResourceNotFoundException",
  TooManyRequestsException: "TooManyRequestsException",
} as const;

export const GetCredentialsForIdentityException = {
  ExternalServiceException: "ExternalServiceException",
  InternalErrorException: "InternalErrorException",
  InvalidIdentityPoolConfigurationException:
    "InvalidIdentityPoolConfigurationException",
  InvalidParameterException: "InvalidParameterException",
  NotAuthorizedException: "NotAuthorizedException",
  ResourceConflictException: "ResourceConflictException",
  ResourceNotFoundException: "ResourceNotFoundException",
  TooManyRequestsException: "TooManyRequestsException",
} as const;

export const GetUserAttributeVerificationException = {
  CodeDeliveryFailureException: "CodeDeliveryFailureException",
  ForbiddenException: "ForbiddenException",
  InternalErrorException: "InternalErrorException",
  InvalidEmailRoleAccessPolicyException:
    "InvalidEmailRoleAccessPolicyException",
  InvalidLambdaResponseException: "InvalidLambdaResponseException",
  InvalidParameterException: "InvalidParameterException",
  InvalidSmsRoleAccessPolicyException: "InvalidSmsRoleAccessPolicyException",
  InvalidSmsRoleTrustRelationshipException:
    "InvalidSmsRoleTrustRelationshipException",
  LimitExceededException: "LimitExceededException",
  NotAuthorizedException: "NotAuthorizedException",
  PasswordResetRequiredException: "PasswordResetRequiredException",
  ResourceNotFoundException: "ResourceNotFoundException",
  TooManyRequestsException: "TooManyRequestsException",
  UnexpectedLambdaException: "UnexpectedLambdaException",
  UserLambdaValidationException: "UserLambdaValidationException",
  UserNotConfirmedException: "UserNotConfirmedException",
  UserNotFoundException: "UserNotFoundException",
} as const;

export const GlobalSignOutException = {
  ForbiddenException: "ForbiddenException",
  InternalErrorException: "InternalErrorException",
  InvalidParameterException: "InvalidParameterException",
  NotAuthorizedException: "NotAuthorizedException",
  PasswordResetRequiredException: "PasswordResetRequiredException",
  ResourceNotFoundException: "ResourceNotFoundException",
  TooManyRequestsException: "TooManyRequestsException",
  UserNotConfirmedException: "UserNotConfirmedException",
} as const;

export const InitiateAuthException = {
  PasswordResetRequiredException: "PasswordResetRequiredException",
  ForbiddenException: "ForbiddenException",
  InternalErrorException: "InternalErrorException",
  InvalidLambdaResponseException: "InvalidLambdaResponseException",
  InvalidParameterException: "InvalidParameterException",
  InvalidSmsRoleAccessPolicyException: "InvalidSmsRoleAccessPolicyException",
  InvalidSmsRoleTrustRelationshipException:
    "InvalidSmsRoleTrustRelationshipException",
  InvalidUserPoolConfigurationException:
    "InvalidUserPoolConfigurationException",
  NotAuthorizedException: "NotAuthorizedException",
  ResourceNotFoundException: "ResourceNotFoundException",
  LimitExceededException: "LimitExceededException",
  TooManyRequestsException: "TooManyRequestsException",
  UnexpectedLambdaException: "UnexpectedLambdaException",
  UserLambdaValidationException: "UserLambdaValidationException",
  UserNotConfirmedException: "UserNotConfirmedException",
  UserNotFoundException: "UserNotFoundException",
} as const;

export const ResendConfirmationException = {
  CodeDeliveryFailureException: "CodeDeliveryFailureException",
  ForbiddenException: "ForbiddenException",
  InternalErrorException: "InternalErrorException",
  InvalidEmailRoleAccessPolicyException:
    "InvalidEmailRoleAccessPolicyException",
  InvalidLambdaResponseException: "InvalidLambdaResponseException",
  InvalidParameterException: "InvalidParameterException",
  InvalidSmsRoleAccessPolicyException: "InvalidSmsRoleAccessPolicyException",
  InvalidSmsRoleTrustRelationshipException:
    "InvalidSmsRoleTrustRelationshipException",
  LimitExceededException: "LimitExceededException",
  NotAuthorizedException: "NotAuthorizedException",
  ResourceNotFoundException: "ResourceNotFoundException",
  TooManyRequestsException: "TooManyRequestsException",
  UnexpectedLambdaException: "UnexpectedLambdaException",
  UserLambdaValidationException: "UserLambdaValidationException",
  UserNotFoundException: "UserNotFoundException",
} as const;

export const RespondToAuthChallengeException = {
  AliasExistsException: "AliasExistsException",
  CodeMismatchException: "CodeMismatchException",
  ExpiredCodeException: "ExpiredCodeException",
  ForbiddenException: "ForbiddenException",
  InternalErrorException: "InternalErrorException",
  InvalidLambdaResponseException: "InvalidLambdaResponseException",
  InvalidParameterException: "InvalidParameterException",
  InvalidPasswordException: "InvalidPasswordException",
  InvalidSmsRoleAccessPolicyException: "InvalidSmsRoleAccessPolicyException",
  InvalidSmsRoleTrustRelationshipException:
    "InvalidSmsRoleTrustRelationshipException",
  InvalidUserPoolConfigurationException:
    "InvalidUserPoolConfigurationException",
  MFAMethodNotFoundException: "MFAMethodNotFoundException",
  NotAuthorizedException: "NotAuthorizedException",
  PasswordResetRequiredException: "PasswordResetRequiredException",
  ResourceNotFoundException: "ResourceNotFoundException",
  SoftwareTokenMFANotFoundException: "SoftwareTokenMFANotFoundException",
  TooManyRequestsException: "TooManyRequestsException",
  UnexpectedLambdaException: "UnexpectedLambdaException",
  UserLambdaValidationException: "UserLambdaValidationException",
  UserNotConfirmedException: "UserNotConfirmedException",
  UserNotFoundException: "UserNotFoundException",
} as const;

export const SetUserMFAPreferenceException = {
  ForbiddenException: "ForbiddenException",
  InternalErrorException: "InternalErrorException",
  InvalidParameterException: "InvalidParameterException",
  NotAuthorizedException: "NotAuthorizedException",
  PasswordResetRequiredException: "PasswordResetRequiredException",
  ResourceNotFoundException: "ResourceNotFoundException",
  UserNotConfirmedException: "UserNotConfirmedException",
  UserNotFoundException: "UserNotFoundException",
} as const;

export const SignUpException = {
  CodeDeliveryFailureException: "CodeDeliveryFailureException",
  InternalErrorException: "InternalErrorException",
  InvalidEmailRoleAccessPolicyException:
    "InvalidEmailRoleAccessPolicyException",
  InvalidLambdaResponseException: "InvalidLambdaResponseException",
  InvalidParameterException: "InvalidParameterException",
  InvalidPasswordException: "InvalidPasswordException",
  InvalidSmsRoleAccessPolicyException: "InvalidSmsRoleAccessPolicyException",
  InvalidSmsRoleTrustRelationshipException:
    "InvalidSmsRoleTrustRelationshipException",
  NotAuthorizedException: "NotAuthorizedException",
  ResourceNotFoundException: "ResourceNotFoundException",
  TooManyRequestsException: "TooManyRequestsException",
  UnexpectedLambdaException: "UnexpectedLambdaException",
  UserLambdaValidationException: "UserLambdaValidationException",
  UsernameExistsException: "UsernameExistsException",
} as const;

export const UpdateUserAttributesException = {
  AliasExistsException: "AliasExistsException",
  CodeDeliveryFailureException: "CodeDeliveryFailureException",
  CodeMismatchException: "CodeMismatchException",
  ExpiredCodeException: "ExpiredCodeException",
  ForbiddenException: "ForbiddenException",
  InternalErrorException: "InternalErrorException",
  InvalidEmailRoleAccessPolicyException:
    "InvalidEmailRoleAccessPolicyException",
  InvalidLambdaResponseException: "InvalidLambdaResponseException",
  InvalidParameterException: "InvalidParameterException",
  InvalidSmsRoleAccessPolicyException: "InvalidSmsRoleAccessPolicyException",
  InvalidSmsRoleTrustRelationshipException:
    "InvalidSmsRoleTrustRelationshipException",
  NotAuthorizedException: "NotAuthorizedException",
  PasswordResetRequiredException: "PasswordResetRequiredException",
  ResourceNotFoundException: "ResourceNotFoundException",
  TooManyRequestsException: "TooManyRequestsException",
  UnexpectedLambdaException: "UnexpectedLambdaException",
  UserLambdaValidationException: "UserLambdaValidationException",
  UserNotConfirmedException: "UserNotConfirmedException",
  UserNotFoundException: "UserNotFoundException",
} as const;

export const VerifySoftwareTokenException = {
  CodeMismatchException: "CodeMismatchException",
  EnableSoftwareTokenMFAException: "EnableSoftwareTokenMFAException",
  ForbiddenException: "ForbiddenException",
  InternalErrorException: "InternalErrorException",
  InvalidParameterException: "InvalidParameterException",
  InvalidUserPoolConfigurationException:
    "InvalidUserPoolConfigurationException",
  NotAuthorizedException: "NotAuthorizedException",
  PasswordResetRequiredException: "PasswordResetRequiredException",
  ResourceNotFoundException: "ResourceNotFoundException",
  SoftwareTokenMFANotFoundException: "SoftwareTokenMFANotFoundException",
  TooManyRequestsException: "TooManyRequestsException",
  UserNotConfirmedException: "UserNotConfirmedException",
  UserNotFoundException: "UserNotFoundException",
} as const;

export const VerifyUserAttributeException = {
  AliasExistsException: "AliasExistsException",
  CodeMismatchException: "CodeMismatchException",
  ExpiredCodeException: "ExpiredCodeException",
  ForbiddenException: "ForbiddenException",
  InternalErrorException: "InternalErrorException",
  InvalidParameterException: "InvalidParameterException",
  LimitExceededException: "LimitExceededException",
  NotAuthorizedException: "NotAuthorizedException",
  PasswordResetRequiredException: "PasswordResetRequiredException",
  ResourceNotFoundException: "ResourceNotFoundException",
  TooManyRequestsException: "TooManyRequestsException",
  UserNotConfirmedException: "UserNotConfirmedException",
  UserNotFoundException: "UserNotFoundException",
} as const;

export const UpdateDeviceStatusException = {
  ForbiddenException: "ForbiddenException",
  InternalErrorException: "InternalErrorException",
  InvalidParameterException: "InvalidParameterException",
  InvalidUserPoolConfigurationException:
    "InvalidUserPoolConfigurationException",
  NotAuthorizedException: "NotAuthorizedException",
  PasswordResetRequiredException: "PasswordResetRequiredException",
  ResourceNotFoundException: "ResourceNotFoundException",
  TooManyRequestsException: "TooManyRequestsException",
  UserNotConfirmedException: "UserNotConfirmedException",
  UserNotFoundException: "UserNotFoundException",
} as const;

export const ListDevicesException = {
  ForbiddenException: "ForbiddenException",
  InternalErrorException: "InternalErrorException",
  InvalidParameterException: "InvalidParameterException",
  InvalidUserPoolConfigurationException:
    "InvalidUserPoolConfigurationException",
  NotAuthorizedException: "NotAuthorizedException",
  PasswordResetRequiredException: "PasswordResetRequiredException",
  ResourceNotFoundException: "ResourceNotFoundException",
  TooManyRequestsException: "TooManyRequestsException",
  UserNotConfirmedException: "UserNotConfirmedException",
  UserNotFoundException: "UserNotFoundException",
} as const;

export const SETUP_TOTP_EXCEPTION = "SetUpTOTPException";
